import type { RunningHubFeatureType } from '../types/runningHubJobs';
import {
  createScopedRunningHubClientItemId,
  type RunningHubHistoryFeatureType,
} from './runningHubCloudHistory';

export function createRunningHubClientItemId(
  featureType: RunningHubFeatureType | RunningHubHistoryFeatureType,
  userEmail?: string | null,
  isAuthenticated?: boolean,
): string {
  return createScopedRunningHubClientItemId(
    featureType as RunningHubHistoryFeatureType,
    userEmail,
    isAuthenticated,
  );
}

export function stripJobMetaFromPayload(payload: Record<string, unknown>): Record<string, unknown> {
  const { _pollMode, ...rest } = payload;
  return rest;
}

export type RunningHubJobClientMeta = {
  clientItemId: string;
  historyPayloadDraft: Record<string, unknown>;
};

export type RunningHubRecoveryRequest = {
  jobId: string;
  featureType: RunningHubFeatureType;
  historyPayload: Record<string, unknown>;
};

export function openPanelForRunningHubFeature(
  featureType: RunningHubFeatureType,
  openers: {
    setIsUpscaleOpen: (v: boolean) => void;
    setIsToneMappingOpen: (v: boolean) => void;
    setIsLightReconstructOpen: (v: boolean) => void;
    setIsTextReconstructOpen: (v: boolean) => void;
    setIsPhysicalReconstructOpen: (v: boolean) => void;
  },
): void {
  switch (featureType) {
    case 'upscale':
      openers.setIsUpscaleOpen(true);
      break;
    case 'tone_mapping':
      openers.setIsToneMappingOpen(true);
      break;
    case 'light_reconstruct':
      openers.setIsLightReconstructOpen(true);
      break;
    case 'text_reconstruct':
      openers.setIsTextReconstructOpen(true);
      break;
    case 'physical_reconstruct':
      openers.setIsPhysicalReconstructOpen(true);
      break;
    default:
      break;
  }
}
